<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap=".5em">
<mg-simple-form *ngIf="form" [formGroup]="form" [errorMessage]="errorMessage" label="Instrument" title="{{item?.nr_Instrument}} ({{item?.type}})" [customActions]="customActions" [dtoClassName]="dtoTypeName">
              
    <mg-simple-form-section title="Relatie">
		<mg-simple-form-row>
			<span mg-colspan-3>
                <mat-form-field pd-size-max>
                    <mg-autocomplete #relatieAutocomplete placeholder="Relatie" formControlName="relatie" [displayFn]= "relatieDisplayFn" [getData]="getRelatieDataSource" (optionSelected)="onRelatieSelected($event)" ></mg-autocomplete>
                    <mat-error>{{getError('relatie')}}</mat-error>
                    <!-- Als customer dan mag dat niet, check adhv leesrechten op de projectregel -->
                    <mg-dto-link matSuffix dtoRoute="relatie" module="relatie" [dtoId]="relatieAutocomplete.value?.id" *ngIf="this.canRead('CIJBorculo.Logic.Projectregel')"></mg-dto-link>
                </mat-form-field>
			</span>
		</mg-simple-form-row>
        <mg-simple-form-row>
			<span>
                <mat-form-field pd-size-max-spacer>
                    <input type="text" placeholder="Afdeling" matInput formControlName="afdeling">
                    <mat-error>{{getError('afdeling')}}</mat-error>
                </mat-form-field>
			</span>
            <span mg-colspan-2>
                <mat-form-field pd-size-max-spacer>
                    <input type="text" placeholder="Referentie Klant" matInput formControlName="nr_Referentie">
                    <mat-error>{{getError('nr_Referentie')}}</mat-error>
                </mat-form-field>
			</span>
		</mg-simple-form-row>
        <mg-simple-form-row>
            <span>
                <mat-form-field pd-size-max-spacer>
                    <mg-autocomplete #contactpersoonAutocomplete placeholder="Contactpersoon" formControlName="bContact" [displayFn]= "contactpersoonDisplayFn" [getData]="getContactpersoonDataSource" (optionSelected)="onContactpersoonSelected($event)"></mg-autocomplete>
                    <mat-error>{{getError('bContact')}}</mat-error>
                    <mg-dto-link matSuffix dtoRoute="contactpersoon" module="contactpersoon" [dtoId]="contactpersoonAutocomplete.value?.id"></mg-dto-link>
                </mat-form-field>
            </span>
			<span mg-colspan-2>
                <mat-form-field pd-size-max>
                    <input type="text" placeholder="Email" matInput formControlName="eMail">
                    <mat-error>{{getError('eMail')}}</mat-error>
                </mat-form-field>
			</span>
		</mg-simple-form-row>
        <mg-simple-form-row>
            <span>
                <mat-form-field pd-size-max-spacer>
                    <mg-autocomplete #personeelAutocomplete placeholder="Beoordeeld" formControlName="personeel" [getData]="getPersoneelDataSource"></mg-autocomplete>
                    <mat-error>{{getError('personeel')}}</mat-error>
                    <mg-dto-link matSuffix dtoRoute="personeel" module="personeel" [dtoId]="personeelAutocomplete.value?.id"></mg-dto-link>
                </mat-form-field>
			</span>
        </mg-simple-form-row>

    </mg-simple-form-section>

    <mg-simple-form-section title="Nummers">
        <mg-simple-form-row>
			<span>
                <mat-form-field>
                    <input type="text" placeholder="Instrument Nr" matInput formControlName="nr_Instrument" (keydown.enter)="this.nr_Fabriek.focus();">
                    <mat-error>{{getError('nr_Instrument')}}</mat-error>
                </mat-form-field>
			</span>
			<span>
                <mat-form-field>
                    <input type="text" #nr_Fabriek placeholder="Serie/Fabriek Nr" matInput formControlName="nr_Fabriek" (keydown.enter)="this.nr_Barcode.focus();">
                    <mat-error>{{getError('nr_Fabriek')}}</mat-error>
                </mat-form-field>
			</span>
			<span>
                <mat-form-field>
                    <input type="text" #nr_Barcode placeholder="Barcode" matInput formControlName="nr_Barcode" (keydown.enter)="this.typeCalculatieAutocomplete.focusInput();">
                    <mat-error>{{getError('nr_Barcode')}}</mat-error>
                </mat-form-field>
			</span>
		</mg-simple-form-row>
		<mg-simple-form-row>
            <span>
                <mat-form-field>
                    <mg-autocomplete #typeCalculatieAutocomplete placeholder="Type Kalibratie" formControlName="typeCalculatie" [getData]="getTypeCalculatieDataSource" (keydown.enter)="this.groep.focus();"></mg-autocomplete>
                    <mat-error>{{getError('typeCalculatie')}}</mat-error>
                </mat-form-field>
			</span>
            <span>
                <mat-form-field pd-size-6>
                    <mat-select #groep formControlName="groep" placeholder="Groep">
                        <mat-option *ngIf="this.MeetInstrumenten" [value]="1">{{getGroep(1)}}</mat-option>
                        <mat-option *ngIf="this.Energie" [value]="2">{{getGroep(2)}}</mat-option>         
                        <mat-option *ngIf="(this.MeetInstrumenten || this.Energie) && !this.isNewItem && this.item.isWerkstandaard == 1" [value]="3">{{getGroep(3)}}</mat-option>         
                    </mat-select>
                    <mat-error>{{getError('groep')}}</mat-error>
                </mat-form-field>
            </span>            
		</mg-simple-form-row>
        <br>        
        <mg-simple-form-row>
            <span>
                <mat-slide-toggle color="accent" formControlName="isWerkstandaard">Werkstandaard</mat-slide-toggle>
                <mg-error-icon [error]="getError('isWerkstandaard')"></mg-error-icon>
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span>
                <mat-slide-toggle color="accent" formControlName="referentieMI">Referentie MI</mat-slide-toggle>
                <mg-error-icon [error]="getError('referentieMI')"></mg-error-icon>
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span>
                <mat-slide-toggle color="accent" formControlName="isVervallen">Vervallen</mat-slide-toggle>
                <mg-error-icon [error]="getError('isVervallen')"></mg-error-icon>
            </span>	
        </mg-simple-form-row>
    </mg-simple-form-section>

    <mg-simple-form-section title="Type/Model">
		<mg-simple-form-row>
			<span mg-colspan-3>
                <mat-form-field pd-size-max-spacer>
                    <mg-autocomplete #instrumentdefinitieAutocomplete placeholder="Instrument" formControlName="instrumentDefinitie" [displayFn]= "instrumentdefinitieDisplayFn" [getData]="getInstrumentDefinitieDataSource" (optionSelected)="onInstrumentDefinitieSelected($event)"></mg-autocomplete>
                    <mat-error>{{getError('instrumentDefinitie')}}</mat-error>
                    <mg-dto-link matSuffix dtoRoute="instrumentDefinitie" module="instrumentDefinitie" [dtoId]="instrumentdefinitieAutocomplete.value?.id"></mg-dto-link>
                </mat-form-field>
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span>
                <mat-form-field pd-size-max-spacer>
                    <input type="text" placeholder="Soort" matInput formControlName="soort" readonly>
                    <mat-error>{{getError('soort')}}</mat-error>
                </mat-form-field>
            </span>
            <span>
                <mat-form-field pd-size-max-spacer>
                    <input type="text" placeholder="Merk" matInput formControlName="merk" readonly>
                    <mat-error>{{getError('merk')}}</mat-error>
                </mat-form-field>
            </span>
			<span>
                <mat-form-field pd-size-max-spacer>
                    <input type="text" placeholder="Type" matInput formControlName="type" readonly>
                    <mat-error>{{getError('type')}}</mat-error>
                </mat-form-field>
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span mg-colspan-3>
                <mat-form-field pd-size-18>
                    <mg-autocomplete #voorbladIDAutocomplete placeholder="Voorblad" formControlName="voorbladID" [getData]="getVoorbladIDDataSource"></mg-autocomplete>
                    <mat-error>{{getError('voorbladID')}}</mat-error>
                    <mg-dto-link matSuffix dtoRoute="voorblad" module="voorblad" [dtoId]="voorbladIDAutocomplete.value?.id"></mg-dto-link>
                </mat-form-field>        
                <mat-form-field pd-size-18>
                    <mg-autocomplete #volgbladIDAutocomplete placeholder="Volgblad" formControlName="volgbladID" [getData]="getVolgbladIDDataSource"></mg-autocomplete>
                    <mat-error>{{getError('volgbladID')}}</mat-error>
                    <mg-dto-link matSuffix dtoRoute="volgblad" module="volgblad" [dtoId]="volgbladIDAutocomplete.value?.id"></mg-dto-link>
                </mat-form-field>        
            </span>
        </mg-simple-form-row>
    </mg-simple-form-section>

    <mg-simple-form-section title="Centix" *ngIf="!this.isNewItem && this.item.relatie?.centixId != null && this.item.relatie?.centixId > 0">
        <mg-simple-form-row>
            <span>
                <mat-form-field>
                    <input type="number" placeholder="CentixId" matInput formControlName="centixId" readonly>
                    <mat-error>{{getError('centixId')}}</mat-error>
                </mat-form-field>        
            </span>
            <span>
                <mat-form-field>
                    <mat-label>Laatste export Centix</mat-label>
                    <input matInput [value]="item.lastExportCentix | date:'medium'" readonly>
                </mat-form-field>
            </span>            
            <span>
                <mat-form-field pd-size-max>
                    <input type="text" placeholder="Geëxporteerd Door" matInput formControlName="lastExportCentixDoor" readonly>
                    <mat-error>{{getError('lastExportCentixDoor')}}</mat-error>
                </mat-form-field>
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span mg-colspan-3>
                <mat-form-field pd-size-max>
                    <input type="text" placeholder="Reden Niet Geëxporteerd" matInput formControlName="reasonNotExported" readonly>
                    <mat-error>{{getError('reasonNotExported')}}</mat-error>
                </mat-form-field>
            </span>
        </mg-simple-form-row>
    </mg-simple-form-section>
      
    <mg-simple-form-section title="Certificering">
        <mg-simple-form-row>
            <span>
                <mat-form-field>
                    <input type="text" placeholder="Certificaat" matInput formControlName="certificaat">
                    <mat-error>{{getError('certificaat')}}</mat-error>
                </mat-form-field>
            </span>
            <span>
                <mat-form-field pd-size-7>
                    <input matInput [matDatepicker]="pickerdKalibratie" placeholder="Kalibratie Datum" formControlName="dKalibratie" [readonly]="!this.item.isWerkstandaard">
                    <mat-datepicker-toggle matSuffix [for]="pickerdKalibratie" [hidden]="!this.item.isWerkstandaard"></mat-datepicker-toggle>
                    <mat-datepicker #pickerdKalibratie></mat-datepicker>
                </mat-form-field>
                
                <mat-form-field pd-size-7>
                    <input matInput [matDatepicker]="pickerdVerlopen" placeholder="Geldig Tot" formControlName="dVerlopen" readonly >
                </mat-form-field>
            </span>
            <span>
                <mat-form-field >
                    <mg-autocomplete #personeelCrossAutocomplete placeholder="Uitvoerder Cross" formControlName="personeel_CrossID" [getData]="getPersoneelCrossDataSource"></mg-autocomplete>
                    <mat-error>{{getError('personeel_CrossID')}}</mat-error>
                    <mg-dto-link matSuffix dtoRoute="personeel" module="personeel" [dtoId]="personeelCrossAutocomplete.value?.id"></mg-dto-link>
                </mat-form-field>
            </span>
        </mg-simple-form-row>
        <mg-simple-form-row>
            <span></span>
            <span>

            </span>
        </mg-simple-form-row>
    </mg-simple-form-section>

    <mg-simple-form-section title="Energie">
        <mg-simple-form-row>
            <span>
                <mat-form-field>
                    <input type="number" placeholder="Bouwjaar" matInput formControlName="enbouwjaar">
                    <mat-error>{{getError('enbouwjaar')}}</mat-error>
                </mat-form-field>
			</span>
			<span>
                <mat-form-field>
                    <input type="text" placeholder="Toelatingscode" matInput formControlName="entoelatingscode">
                    <mat-error>{{getError('entoelatingscode')}}</mat-error>
                </mat-form-field>
			</span>
			<span>
                <mat-form-field>
                    <input type="text" placeholder="Code" matInput formControlName="eNcode">
                    <mat-error>{{getError('eNcode')}}</mat-error>
                </mat-form-field>
            </span>
        </mg-simple-form-row>
		<mg-simple-form-row>
            <span>
                <mat-form-field>
                    <input type="text" placeholder="Unom" matInput formControlName="enunom">
                    <mat-error>{{getError('enunom')}}</mat-error>
                </mat-form-field>
			</span>
			<span>
                <mat-form-field>
                    <input type="text" placeholder="Inom" matInput formControlName="eninom">
                    <mat-error>{{getError('eninom')}}</mat-error>
                </mat-form-field>
			</span>
		</mg-simple-form-row>
    </mg-simple-form-section>

    <mg-simple-form-section title="Oproepen">
        <mg-simple-form-row>
			<span>
                <mat-slide-toggle color="accent" formControlName="oproep">Oproepen</mat-slide-toggle>
                <mg-error-icon [error]="getError('oproep')"></mg-error-icon>
			</span>			
		</mg-simple-form-row>
        <br>
        <mg-simple-form-row>
            <span>
                <mat-form-field>
                    <input type="number" placeholder="Termijn (mnd)" matInput formControlName="periode">
                    <mat-error>{{getError('periode')}}</mat-error>
                </mat-form-field>
            </span>
			<span>
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerdOproep" placeholder="Oproepdatum" formControlName="dOproep">
                    <mat-datepicker-toggle matSuffix [for]="pickerdOproep"></mat-datepicker-toggle>
                    <mat-datepicker #pickerdOproep></mat-datepicker>
                    <mat-error>{{getError('dOproep')}}</mat-error>
                </mat-form-field>
			</span>
		
		</mg-simple-form-row>

    </mg-simple-form-section>

    <mg-simple-form-section title="Opmerking">
        <mg-simple-form-row>
			<span mg-colspan-3>
                <mat-form-field pd-size-max>
                    <textarea cdkTextareaAutosize type="text" placeholder="Opmerking" matInput formControlName="opmerking" class="TextareaLineHeight"></textarea>                    
                    <mat-error>{{getError('opmerking')}}</mat-error>
                </mat-form-field>
			</span>
		</mg-simple-form-row>
    </mg-simple-form-section>

    <mg-simple-form-section title="Overig">
		
		<mg-simple-form-row>
			<span>
                <mat-form-field>
                    <input type="text" placeholder="Lokatie" matInput formControlName="lokatie">
                    <mat-error>{{getError('lokatie')}}</mat-error>
                </mat-form-field>
			</span>
			<span>
                <mat-form-field>
                    <input type="text" placeholder="Memo" matInput formControlName="memo">
                    <mat-error>{{getError('memo')}}</mat-error>
                </mat-form-field>
               
			</span>
		</mg-simple-form-row>
	</mg-simple-form-section>


</mg-simple-form>

    <div fxLayout="column" style="float: left;">
        
        <ng-container *ngIf="item && !isNewItem">
            <mat-tab-group>
                <mat-tab *ngIf="this.canRead('CIJBorculo.Logic.OproepHistorie')" >
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Oproep Historie</div>
                    </ng-template> 

                    <mg-subcollection title="Oproep Historie" *mgIfCanRead="'CIJBorculo.Logic.OproepHistorie'" addable="false" >
                        <c-i-j-borculo-oproep-historie-collection #collection [instrument]="item" [defaultPageSize]="20" ></c-i-j-borculo-oproep-historie-collection>
                    </mg-subcollection>
                </mat-tab>
                <mat-tab *ngIf="this.canRead('CIJBorculo.Logic.Projectregel')">
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Projectregels</div>
                    </ng-template> 

                    <mg-subcollection title="Projectregels" *mgIfCanRead="'CIJBorculo.Logic.Projectregel'" addable="false" deletable="false" >
                        <c-i-j-borculo-projectregel-collection #collection [instrument]="item" [relatie]="item?.relatie" [defaultPageSize]="20"></c-i-j-borculo-projectregel-collection>
                    </mg-subcollection>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
               
    </div> 
</div>
